module.exports = __webpack_public_path__ + "img/icon-reset.803279d3.svg";